<template>
	<div class="conteudo">
		<fl-cabecalho-cadastro :id="form.id" @volta-cadastro="$emit('volta-lista')" v-if="menu == false" />

		<fl-dados-cadastrais
			ref="cadastro_usuario"
			:menu="menu"
			:existeTrigrama="_idCliente == '9' || _idCliente == '18' ? true : false"
			@setar-login-senha="setarLoginSenhaUsandoCPF"
			@form-cadastro="formDadosCadastrais"
			:orgaos="orgaos"
			:token="token"
		/>

		<fl-dados-civ ref="dados_civ" @dados-civ="dadosCIV" />

		<fl-acesso-sistema
			ref="acesso_sistema"
			@dados-acesso-sistema="dadosAcessoSistema"
			@getCPF="$refs.cadastro_usuario.validaCPF()"
			:menu="menu"
			:token="token"
			:perfis="perfis"
		/>

		<div>
			<fl-cliente-siga
				v-if="_idCliente == 9 || _idCliente == 10 || _idCliente == 33"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>
			<fl-cliente-ibama
				v-if="_idCliente == 5"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>
			<fl-cliente-alagoas
				v-if="_idCliente == 1"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>
			<fl-cliente-bahia
				v-if="_idCliente == 8"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>

			<fl-cliente-vale
				v-if="_idCliente == 25"
				ref="usuario"
				@seta-dados="
					(_form) => {
						form.pais = _form.pais
						form.localizacao = _form.localizacao
						form.companhia = _form.companhia
						form.job_level = _form.job_level
						form.centro_custo = _form.centro_custo
						form.status_funcionario = _form.status_funcionario
						form.unidade_negocio = _form.unidade_negocio
						form.estado = _form.estado
						form.job_role = _form.job_role
					}
				"
			/>

			<fl-cliente-PM-ES
				v-if="_idCliente == 18"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>
		</div>

		<hr />
		<div class="row" style="margin-bottom: 10px;">
			<div class="col-xs-6">
				<button
					class="btn btn-danger pull-left"
					:class="{'col-xs-3': !_isMobile}"
					@click="modalDesativarUsuario()"
					v-if="form.id != 0 && menu == false && form.status == 1"
				>
					<i class="fa fa-fw fa-trash-o"></i>
					{{ _traducao('global', 'desativar').toUpperCase() }}
				</button>
				<button
					class="btn no-print btn-success"
					:class="{'col-xs-3': !_isMobile}"
					v-if="form.status == 0 && form.id != 0"
					style="margin-right: 20px;"
					@click="modalAtivarUsuario()"
				>
					<i class="fa fa-check-circle fa-fw"></i>
					{{ _traducao('global', 'ativar').toUpperCase() }}
				</button>
			</div>
			<div class="col-xs-6">
				<button class="btn btn-success pull-right" :class="{'col-xs-3': !_isMobile}" @click="clickSalvar()">
					<span v-if="form.id != 0">
						<i class="fa fa-fw fa-check"></i>
						{{ _traducao('global', 'atualizar').toUpperCase() }}
					</span>
					<span v-if="form.id == 0">
						<i class="fa fa-fw fa-check"></i>
						{{ _traducao('global', 'salvar').toUpperCase() }}
					</span>
				</button>
			</div>
		</div>

		<fl-desativar-usuario :form="form" ref="desativar_usuario" @excluido="usuarioExcluirOuAtivar" />
		<fl-ativar-usuario :form="form" ref="ativar_usuario" @ativado="usuarioExcluirOuAtivar" />
	</div>
</template>
<script>
import flCabecalhoCadastro from './cabecalho/main.vue'
import flDadosCadastrais from './componentes/dados-cadastrais.vue'
import flAcessoSistema from './componentes/acesso-sistema.vue'
import flDesativarUsuario from './componentes/modal/modal-desativar-usuario.vue'
import flAtivarUsuario from './componentes/modal/modal-ativar-usuario.vue'
import flDadosCiv from './componentes/dados-civ.vue'

import flClienteSiga from './mg-siga/cadastro.vue'
import flClienteIbama from './ibama/cadastro.vue'
import flClienteBahia from './cm-bahia/cadastro.vue'
import flClienteAlagoas from './alagoas/cadastro.vue'
import flClienteVale from './vale/cadastro.vue'
import flClientePMES from './pm-es/cadastro.vue'

export default {
	components: {
		flCabecalhoCadastro,
		flDadosCadastrais,
		flAcessoSistema,
		flDesativarUsuario,
		flAtivarUsuario,
		flDadosCiv,

		flClienteSiga,
		flClienteIbama,
		flClienteAlagoas,
		flClienteBahia,
		flClienteVale,
		flClientePMES
	},

	props: {
		carregaInformacoes: {
			default: true,
			type: Boolean,
			require: false
		}
	},

	data() {
		return {
			tipo: '',
			menu: false,
			exibe_modal_desativar: false,
			guarnicoes: [],
			postos: [],
			cargos: [],
			perfis: [],
			orgaos: [],
			token: null,

			dadosForm: {},

			form: {
				acesso_sistema: 1,
				alergia: '',
				anac: '',
				assinatura: '',
				atualiza_assinatura: '0',
				atualiza_senha: '0',
				bairro: '',
				bairro_emergencia: '',
				bairro_funcional: '',
				cargo: '',
				posto_graduacao: '',
				celular: '',
				celular2: '',
				celular_emergencia: '',
				cep: '',
				cep_emergencia: '',
				cep_funcional: '',
				certificado_icp: '0',
				cidade: '',
				cidade_emergencia: '',
				cidade_funcional: '',
				codigo_anac: '',
				complemento: '',
				complemento_emergencia: '',
				complemento_funcional: '',
				cpf: '',
				data_nascimento: '',
				departamento: '',
				email: '',
				esta_guarnicao: 0,
				estado: '',
				estado_emergencia: '',
				estado_funcional: '',
				fator_rh: '',
				foto: '',
				foto_antiga: '',
				grau_emergencia: '',
				guarnicao: '',
				id: 0,
				id_guarnicao: 0,
				id_perfil: '',
				id_pessoa: '',
				id_posto_graduacao: '',
				id_usuario: window.$sessao.getId(),
				id_usuario_cargo: '',
				id_usuario_departamento: '',
				identidade: '',
				login: '',
				logradouro: '',
				logradouro_emergencia: '',
				logradouro_funcional: '',
				masp: '',
				matricula: '',
				nome: '',
				nome_emergencia: '',
				nome_guerra: '',
				numero: '',
				numero_emergencia: '',
				numero_funcional: '',
				numero_ordem: '',
				orgao: '',
				perfis: [],
				senha: '',
				senha_icp: '',
				status: 1,
				telefone: '',
				telefone2: '',
				telefone_emergencia: '',
				tipo_certificado: '',
				tipo_sanguineo: '',
				trigrama: '',
				validade_exame: '',
				pais: '',
				localizacao: '',
				companhia: '',
				job_level: '',
				centro_custo: '',
				status_funcionario: '',
				unidade_negocio: '',
				estado: '',
				job_role: '',
				horas_voo: '',
				horas_voo_segundo: '',
				data_horas_voo: '',
				data_horas_voo_segundo: ''
			}
		}
	},

	created() {
		if (this.carregaInformacoes) {
			this.carregaDados(null)
		}
	},

	methods: {
		novo(objetoParaSerCriado) {
			this.menu = objetoParaSerCriado.menu
		},

		usuarioExcluirOuAtivar(usuarioParaSerExcluido) {
			this.$emit('atualiza-lista-usuarios', usuarioParaSerExcluido)
		},

		editar(objetoParaSerEditado) {
			this.menu = objetoParaSerEditado.menu
			this.carregaDadosUser(objetoParaSerEditado)
		},

		carregaUsuarioLogado(objetoParaSerCarregadoJuntoAoUsuario) {
			this.menu = objetoParaSerCarregadoJuntoAoUsuario.menu

			if (!this.isNil(objetoParaSerCarregadoJuntoAoUsuario.token)) {
				this.token = objetoParaSerCarregadoJuntoAoUsuario.token
				this.carregaDados(this.token)
			}

			this.$nextTick(() => {
				this.carregaDadosUser(objetoParaSerCarregadoJuntoAoUsuario)
			})
		},

		// RECEBES OS DADOS DO COMPONENTE CADASTRO
		carregaForm(dados) {
			this.dadosForm = dados.form
		},

		/* Conferindo se o valor é nulo ou undefined */

		isNil(value) {
			return value === null || value === undefined
		},

		carregaDadosUser(objetoParaSerCarregado) {
			this.form.id = objetoParaSerCarregado.id

			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			this._httpGet(
				'/Usuario/editar/' + this.form.id,
				(retorno) => {
					window.bus.$emit('load-out')
					if (retorno._request && retorno._status) {
						this.carregaDadosUsuario(retorno)

						this.$nextTick(() => {
							this.$refs.cadastro_usuario.editar(this.form)
							this.$refs.acesso_sistema.editar(this.form)
							this.$refs.dados_civ.editar(this.form)
						})

						if (
							window.$cliente.get('id') == '9' ||
							window.$cliente.get('id') == '10' ||
							window.$cliente.get('id') == '33' ||
							window.$cliente.get('id') == '25' ||
							window.$cliente.get('id') == '5' ||
							window.$cliente.get('id') == '1' ||
							window.$cliente.get('id') == '18'
						) {
							this.$refs.usuario.editar(this.form)
						}
					}
				},
				this.token
			)
		},

		carregaDadosUsuario(dados) {
			this.form.novo_usuario =
				this._trataRetornoVazio(dados.usuario.novo_usuario) == '' ? '0' : this._trataRetornoVazio(dados.usuario.novo_usuario)
			this.form.foto = this._trataRetornoVazio(dados.usuario.foto)
			this.form.foto_antiga = this._trataRetornoVazio(dados.usuario.foto_antiga)
			this.form.anac = this._trataRetornoVazio(dados.usuario.codigo_anac)
			this.form.celular = this._trataRetornoVazio(dados.usuario.celular)
			this.form.celular2 = this._trataRetornoVazio(dados.usuario.celular2)
			this.form.codigo_anac = this._trataRetornoVazio(dados.usuario.codigo_anac)
			this.form.cpf = this._trataRetornoVazio(dados.usuario.cpf)
			this.form.email = this._trataRetornoVazio(dados.usuario.email)
			this.form.nome = this._trataRetornoVazio(dados.usuario.nome)
			this.form.orgao = this._trataRetornoVazio(dados.usuario.id_orgao)
			this.form.telefone = this._trataRetornoVazio(dados.usuario.telefone)
			this.form.telefone2 = this._trataRetornoVazio(dados.usuario.telefone2)
			this.form.trigrama = this._trataRetornoVazio(dados.usuario.trigrama)

			this.carregaAcessoAoSistema(dados)
		},

		carregaAcessoAoSistema(dados) {
			this.form.atualiza_assinatura = this._trataRetornoVazio(dados.usuario.atualiza_assinatura)
			this.form.atualiza_senha = this._trataRetornoVazio(dados.usuario.atualiza_senha)
			this.form.certificado_icp = this._trataRetornoVazio(dados.usuario.certificado_icp)
			this.form.login = this._trataRetornoVazio(dados.usuario.login)
			this.form.perfis = dados.perfis

			if (this.form.perfis.length == 1) {
				if (this.form.perfis[0].id == 21) {
					this.form.tipo = 'S'
				} else {
					this.form.tipo = 'O'
				}
			} else {
				this.form.tipo = 'O'
			}

			this.form.acesso_sistema = this.form.perfis.length == 0 ? '0' : '1'
			this.carregaEndereco(dados)
		},

		carregaEndereco(dados) {
			this.form.bairro = this._trataRetornoVazio(dados.usuario.bairro)
			this.form.bairro_emergencia = this._trataRetornoVazio(dados.usuario.bairro_emergencia)
			this.form.bairro_funcional = this._trataRetornoVazio(dados.usuario.bairro_funcional)
			this.form.cep = this._trataRetornoVazio(dados.usuario.cep)
			this.form.cep_emergencia = this._trataRetornoVazio(dados.usuario.cep_emergencia)
			this.form.cep_funcional = this._trataRetornoVazio(dados.usuario.cep_funcional)
			this.form.cidade = this._trataRetornoVazio(dados.usuario.cidade)
			this.form.cidade_emergencia = this._trataRetornoVazio(dados.usuario.cidade_emergencia)
			this.form.cidade_funcional = this._trataRetornoVazio(dados.usuario.cidade_funcional)
			this.form.complemento = this._trataRetornoVazio(dados.usuario.complemento)
			this.form.complemento_emergencia = this._trataRetornoVazio(dados.usuario.complemento_emergencia)
			this.form.complemento_funcional = this._trataRetornoVazio(dados.usuario.complemento_funcional)
			this.form.estado = this._trataRetornoVazio(dados.usuario.estado)
			this.form.estado_emergencia = this._trataRetornoVazio(dados.usuario.estado_emergencia)
			this.form.estado_funcional = this._trataRetornoVazio(dados.usuario.estado_funcional)
			this.form.logradouro = this._trataRetornoVazio(dados.usuario.logradouro)
			this.form.logradouro_emergencia = this._trataRetornoVazio(dados.usuario.logradouro_emergencia)
			this.form.logradouro_funcional = this._trataRetornoVazio(dados.usuario.logradouro_funcional)
			this.form.numero = this._trataRetornoVazio(dados.usuario.numero)
			this.form.numero_emergencia = this._trataRetornoVazio(dados.usuario.numero_emergencia)
			this.form.numero_funcional = this._trataRetornoVazio(dados.usuario.numero_funcional)

			this.form._controleAdicional = this.form.cep == '' ? false : true

			this.carregaTipoUsuario(dados)
		},

		carregaTipoUsuario(dados) {
			this.form.masp = this._trataRetornoVazio(dados.usuario.masp)
			this.form.data_nascimento = this._trataRetornoVazio(
				this._SQLDateToDate(dados.usuario.data_nascimento, window.$sessao.getDateFormat())
			)
			this.form.cargo = this._trataRetornoVazio(dados.usuario.cargo)
			this.form.nome_guerra = this._trataRetornoVazio(dados.usuario.nome_guerra)
			this.form.id_posto_graduacao = this._trataRetornoVazio(dados.usuario.id_posto_graduacao)

			this.carregaDadosEmergencia(dados)
		},

		carregaDadosEmergencia(dados) {
			this.form.tipo_sanguineo = this._trataRetornoVazio(dados.usuario.tipo_sanguineo)
			this.form.fator_rh = this._trataRetornoVazio(dados.usuario.fator_rh)
			this.form.alergia = this._trataRetornoVazio(dados.usuario.alergia)
			this.form.nome_emergencia = this._trataRetornoVazio(dados.usuario.nome_emergencia)
			this.form.grau_emergencia = this._trataRetornoVazio(dados.usuario.grau_emergencia)
			this.form.telefone_emergencia = this._trataRetornoVazio(dados.usuario.telefone_emergencia)
			this.form.celular_emergencia = this._trataRetornoVazio(dados.usuario.celular_emergencia)

			this.carregaDadosAdicionais(dados)
		},

		carregaDadosAdicionais(dados) {
			this.form.identidade = this._trataRetornoVazio(dados.usuario.identidade)
			this.form.departamento = this._trataRetornoVazio(dados.usuario.departamento)
			this.form.guarnicao = this._trataRetornoVazio(dados.usuario.tipo_guarnicao)
			this.form.matricula = this._trataRetornoVazio(dados.usuario.matricula)
			this.form.tipo_guarnicao = this._trataRetornoVazio(dados.usuario.tipo_guarnicao)
			this.form.tipo_certificado = this._trataRetornoVazio(dados.usuario.id_tipo_certificado)
			this.form.validade_exame = this._trataRetornoVazio(
				this._SQLDateToDate(dados.usuario.validade_exame, window.$sessao.getDateFormat())
			)
			this.form.id_guarnicao = this._trataRetornoVazio(dados.usuario.id_guarnicao)
			this.form.id_pessoa = this._trataRetornoVazio(dados.usuario.id_pessoa)
			this.form.id_usuario = this._trataRetornoVazio(dados.usuario.id_usuario)
			this.form.id_usuario_cargo = this._trataRetornoVazio(dados.usuario.id_usuario_cargo)
			this.form.id_posto_graduacao = this._trataRetornoVazio(dados.usuario.id_posto_graduacao)
			this.form.id_usuario_departamento = this._trataRetornoVazio(dados.usuario.id_usuario_departamento)

			this.form.numero_ordem = this._trataRetornoVazio(dados.usuario.numero_ordem)
			this.form.status = this._trataRetornoVazio(dados.usuario.status)

			this.form.esta_guarnicao = this.form.tipo_guarnicao == '' ? '0' : '1'

			this.carregaIAMDadosVale(dados)
		},

		carregaIAMDadosVale(dados) {
			this.form.pais = this._trataRetornoVazio(dados.usuario.pais)
			this.form.localizacao = this._trataRetornoVazio(dados.usuario.localizacao)
			this.form.companhia = this._trataRetornoVazio(dados.usuario.companhia)
			this.form.job_level = this._trataRetornoVazio(dados.usuario.job_level)
			this.form.centro_custo = this._trataRetornoVazio(dados.usuario.centro_custo)
			this.form.status_funcionario = this._trataRetornoVazio(dados.usuario.status_funcionario)
			this.form.unidade_negocio = this._trataRetornoVazio(dados.usuario.unidade_negocio)
			this.form.estado = this._trataRetornoVazio(dados.usuario.estado)
			this.form.job_role = this._trataRetornoVazio(dados.usuario.job_role)

			this.carregaDadosCiv(dados)
		},

		carregaDadosCiv(dados) {
			this.form.horas_voo = this._trataRetornoVazio(dados.usuario.horas_voo)
			this.form.horas_voo_segundo = this._trataRetornoVazio(dados.usuario.horas_voo_segundo)
			this.form.data_horas_voo = this._trataRetornoVazio(
				this._SQLDateToDate(dados.usuario.data_horas_voo, window.$sessao.getDateFormat())
			)
			this.form.data_horas_voo_segundo = this._trataRetornoVazio(
				this._SQLDateToDate(dados.usuario.data_horas_voo_segundo, window.$sessao.getDateFormat())
			)
		},

		getPerfilPorId(id) {
			this.perfis.find((perfil) => {
				return perfil.id === id
			})
		},

		setaDadosCadastrais() {
			if (!this.isNil(this.dados_cadastrais)) {
				this.form.id = this._trataRetornoVazio(this.dados_cadastrais.id)
				this.form.celular = this._trataRetornoVazio(this.dados_cadastrais.celular)
				this.form.celular2 = this._trataRetornoVazio(this.dados_cadastrais.celular2)
				this.form.codigo_anac = this._trataRetornoVazio(this.dados_cadastrais.codigo_anac)
				this.form.anac = this._trataRetornoVazio(this.dados_cadastrais.codigo_anac)
				this.form.cpf = this._trataRetornoVazio(this.dados_cadastrais.cpf)
				this.form.email = this._trataRetornoVazio(this.dados_cadastrais.email)
				this.form.foto = this._trataRetornoVazio(this.dados_cadastrais.foto)
				this.form.foto_antiga = this._trataRetornoVazio(this.dados_cadastrais.foto_antiga)
				this.form.id_usuario = this._trataRetornoVazio(this.dados_cadastrais.id_usuario)
				this.form.nome = this._trataRetornoVazio(this.dados_cadastrais.nome)
				this.form.orgao = this._trataRetornoVazio(this.dados_cadastrais.orgao)
				this.form.telefone = this._trataRetornoVazio(this.dados_cadastrais.telefone)
				this.form.trigrama = this._trataRetornoVazio(this.dados_cadastrais.trigrama)
			}
		},

		setaDadosCiv() {
			if (!this.isNil(this.dados_civ)) {
				this.form.horas_voo = this._trataRetornoVazio(this.dados_civ.horas_voo)
				this.form.horas_voo_segundo = this._trataRetornoVazio(this.dados_civ.horas_voo_segundo)
				this.form.data_horas_voo = this._trataRetornoVazio(
					this._dateToDateSQL(this.dados_civ.data_horas_voo, window.$sessao.getDateFormat())
				)
				this.form.data_horas_voo_segundo = this._trataRetornoVazio(
					this._dateToDateSQL(this.dados_civ.data_horas_voo_segundo, window.$sessao.getDateFormat())
				)
			}
		},

		setarLoginSenhaUsandoCPF(cpf) {
			this.$refs.acesso_sistema.setaLoginSenha(cpf)
		},

		formDadosCadastrais(itemParaSerGeradoForm) {
			this.dados_cadastrais = itemParaSerGeradoForm
		},

		dadosCIV(itemDadosCiv) {
			this.dados_civ = itemDadosCiv
		},

		dadosAcessoSistema(dadosSistema) {
			this.dados_acesso_sistema = dadosSistema
		},

		setaAcessoSistema() {
			if (!this.isNil(this.dados_acesso_sistema)) {
				this.form.acesso_sistema = this._trataRetornoVazio(this.dados_acesso_sistema.acesso_sistema)
				this.form.assinatura = this._trataRetornoVazio(this.dados_acesso_sistema.assinatura)
				this.form.atualiza_assinatura = this._trataRetornoVazio(this.dados_acesso_sistema.atualiza_assinatura)
				this.form.atualiza_senha = this._trataRetornoVazio(this.dados_acesso_sistema.atualiza_senha)
				this.form.certificado_icp = this._trataRetornoVazio(this.dados_acesso_sistema.certificado_icp)
				this.form.id_perfil = this._trataRetornoVazio(this.dados_acesso_sistema.id_perfil)
				this.form.login = this._trataRetornoVazio(this.dados_acesso_sistema.login)
				this.form.perfis = this._trataRetornoVazio(this.dados_acesso_sistema.perfis)
				this.form.senha = this._trataRetornoVazio(this.dados_acesso_sistema.senha)
				this.form.senha_icp = this._trataRetornoVazio(this.dados_acesso_sistema.senha_icp)
			}
		},

		setaEnderecoResidencial() {
			if (!this.isNil(this.dadosForm.dados_endereco_residencial)) {
				this.form.bairro = this._trataRetornoVazio(this.dadosForm.dados_endereco_residencial.bairro)
				this.form.cep = this._trataRetornoVazio(this.dadosForm.dados_endereco_residencial.cep)
				this.form.cidade = this._trataRetornoVazio(this.dadosForm.dados_endereco_residencial.cidade)
				this.form.complemento = this._trataRetornoVazio(this.dadosForm.dados_endereco_residencial.complemento)
				this.form.estado = this._trataRetornoVazio(this.dadosForm.dados_endereco_residencial.estado)
				this.form.logradouro = this._trataRetornoVazio(this.dadosForm.dados_endereco_residencial.logradouro)
				this.form.numero = this._trataRetornoVazio(this.dadosForm.dados_endereco_residencial.numero)
			}
		},

		setaEnderecoFuncional() {
			if (!this.isNil(this.dadosForm.dados_endereco_funcional)) {
				this.form.bairro_funcional = this._trataRetornoVazio(this.dadosForm.dados_endereco_funcional.bairro)
				this.form.cep_funcional = this._trataRetornoVazio(this.dadosForm.dados_endereco_funcional.cep)
				this.form.cidade_funcional = this._trataRetornoVazio(this.dadosForm.dados_endereco_funcional.cidade)
				this.form.complemento_funcional = this._trataRetornoVazio(this.dadosForm.dados_endereco_funcional.complemento)
				this.form.estado_funcional = this._trataRetornoVazio(this.dadosForm.dados_endereco_funcional.estado)
				this.form.logradouro_funcional = this._trataRetornoVazio(this.dadosForm.dados_endereco_funcional.logradouro)
				this.form.numero_funcional = this._trataRetornoVazio(this.dadosForm.dados_endereco_funcional.numero)
			}
		},

		setaEnderecoEmergencial() {
			if (!this.isNil(this.dadosForm.dados_endereco_emergencial)) {
				this.form.bairro_emergencia = this._trataRetornoVazio(this.dadosForm.dados_endereco_emergencial.bairro)
				this.form.cep_emergencia = this._trataRetornoVazio(this.dadosForm.dados_endereco_emergencial.cep)
				this.form.cidade_emergencia = this._trataRetornoVazio(this.dadosForm.dados_endereco_emergencial.cidade)
				this.form.complemento_emergencia = this._trataRetornoVazio(this.dadosForm.dados_endereco_emergencial.complemento)
				this.form.estado_emergencia = this._trataRetornoVazio(this.dadosForm.dados_endereco_emergencial.estado)
				this.form.logradouro_emergencia = this._trataRetornoVazio(this.dadosForm.dados_endereco_emergencial.logradouro)
				this.form.numero_emergencia = this._trataRetornoVazio(this.dadosForm.dados_endereco_emergencial.numero)
			}
		},

		setaDadosAdicionais() {
			if (!this.isNil(this.dadosForm.dados_emergencia)) {
				this.form.alergia = this._trataRetornoVazio(this.dadosForm.dados_emergencia.alergia)
				this.form.fator_rh = this._trataRetornoVazio(this.dadosForm.dados_emergencia.fator_rh)
				this.form.tipo_sanguineo = this._trataRetornoVazio(this.dadosForm.dados_emergencia.tipo_sanguineo)
			}

			if (!this.isNil(this.dadosForm.dados_contato_emergencial)) {
				this.form.celular_emergencia = this._trataRetornoVazio(this.dadosForm.dados_contato_emergencial.celular_emergencia)
				this.form.grau_emergencia = this._trataRetornoVazio(this.dadosForm.dados_contato_emergencial.grau_emergencia)
				this.form.nome_emergencia = this._trataRetornoVazio(this.dadosForm.dados_contato_emergencial.nome_emergencia)
				this.form.telefone_emergencia = this._trataRetornoVazio(this.dadosForm.dados_contato_emergencial.telefone_emergencia)

				this.form.tipo = this._trataRetornoVazio(this.dadosForm.tipo)
			}

			if (!this.isNil(this.dadosForm.dados_adicionais)) {
				this.form.cargo = this._trataRetornoVazio(this.dadosForm.dados_adicionais.cargo)
				this.form.id_posto_graduacao = this._trataRetornoVazio(this.dadosForm.dados_adicionais.id_posto_graduacao)
				this.form.data_nascimento = this._trataRetornoVazio(
					this._dateToDateSQL(this.dadosForm.dados_adicionais.data_nascimento, window.$sessao.getDateFormat())
				)
				this.form.masp = this._trataRetornoVazio(this.dadosForm.dados_adicionais.masp)
				this.form.nome_guerra = this._trataRetornoVazio(this.dadosForm.dados_adicionais.nome_guerra)
				this.form.identidade = this._trataRetornoVazio(this.dadosForm.dados_adicionais.identidade)
				this.form.matricula = this._trataRetornoVazio(this.dadosForm.dados_adicionais.matricula)
				this.form.numero_ordem = this._trataRetornoVazio(this.dadosForm.dados_adicionais.numero_ordem)
			}
		},

		modalDesativarUsuario() {
			this.$refs.desativar_usuario.carregaModal()
		},

		modalAtivarUsuario() {
			this.$refs.ativar_usuario.carregaModalAtivar()
		},

		clickSalvar() {
			if (this.validaForm()) {
				this.setaDadosCadastrais()
				this.setaDadosCiv()
				this.setaAcessoSistema()
				this.setaEnderecoResidencial()
				this.setaEnderecoFuncional()
				this.setaEnderecoEmergencial()
				this.setaDadosAdicionais()

				if (
					window.$cliente.get('id') == '9' ||
					window.$cliente.get('id') == '10' ||
					window.$cliente.get('id') == '18' ||
					window.$cliente.get('id') == '33'
				) {
					//verificando se é S
					if (this.form.tipo == 'S') {
						this.form.perfis = []
						this.form.perfis.push({id: 4})
					}
				}

				if (this.form.id == 0) {
					window.bus.$emit('load-in', {
						text: this._traducao('global', 'salvando')
					})
				} else {
					window.bus.$emit('load-in', {text: this._traducao('global', 'atualizando')})
				}

				this.$nextTick(() => {
					this.salvar()
				})
			} else {
				window.bus.$emit('exibir-notificacao', {
					text: this._traducao('global', 'favorPreencherCamposEmVermelho'),
					type: 'danger'
				})
			}
		},

		validaForm() {
			let passou = true

			if (!this.$refs.cadastro_usuario.validaForm()) {
				passou = false
			}

			if (!this.$refs.acesso_sistema.validaForm()) {
				passou = false
			}

			// VALIDAÇÃO DO FORMULÁRIO COMPLETO
			if (
				window.$cliente.get('id') == '1' ||
				window.$cliente.get('id') == '5' ||
				window.$cliente.get('id') == '8' ||
				window.$cliente.get('id') == '9' ||
				window.$cliente.get('id') == '10' ||
				window.$cliente.get('id') == '18' ||
				window.$cliente.get('id') == '25' ||
				window.$cliente.get('id') == '33'
			) {
				//  Tratamento de ERROR
				if (!this.$refs.usuario.validaForm()) {
					passou = false
				} else {
					passou = true
				}

				this.$refs.dados_civ.validaForm()
			}

			return passou
		},

		// ENVIA O FORMULÀRIO PARA O BACK
		salvar() {
			this._httpPost(
				'/Usuario/salvar',
				this.form,
				(retorno) => {
					window.bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						if (window.$sessao.getId() == this.form.id) {
							window.$sessao.setFoto(this.form.foto)
						}

						if (this.menu == true) {
							window.bus.$emit('exibir-notificacao', {
								type: 'success',
								text: this._traducao('menuSolicitaApoio', 'dadosAtualizados')
							})
						}

						this.$emit('atualiza-lista', retorno.lista[0])
					} else {
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.mensagem || this._traducao('global', 'naoFoiPossivelCadastrarUsuario')
						})
					}
				},
				this.token
			)
		},

		// REQUISIÇÃO PARA RETORNAR OS VALORES DO SELECT
		carregaDados(token) {
			// Get Orgãos
			this._httpGet(
				'/Orgao/get_orgao',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.orgaos = retorno.lista
					}
				},
				token
			)

			// Get Perfil
			this._httpGet(
				'/Perfil/get',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.perfis = retorno.lista
					}
				},
				token
			)

			// Get Postos/Graduação
			this._httpGet(
				'/Usuario/get_posto_graduacao',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.postos = retorno.lista
					}
				},
				token
			)

			// Get Guarnição
			this._httpGet(
				'/Guarnicao/get_tipo_guarnicao',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.guarnicoes = retorno.lista
					}
				},
				token
			)

			// Get Cargo
			this._httpGet(
				'/Cargo/get_cargo',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.cargos = retorno.lista
					}
				},
				token
			)
		}
	}
}
</script>